import RpcService  from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

import type { RequestOptions } from "@/core/services/Rpc/RpcService";

import type Partner           from "@/domains/Partners/Partner";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort       from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с партнёрами
 */
class PartnersDAO {

	/**
	 * Загружает одного партнёра по ID
	 */
	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('partners.get', { id });
	}

	/**
	 * Загружает список партнёров
	 *
	 * options — опции запроса (abortPrevious, signal, timeout), передаются в RpcService как есть.
	 */
	static async getList(
		filters?: {
			pattern?:                   string;
			personPattern?:             string;
			companyPattern?:            string;
			responsiblePattern?:        string;
			isOperationsAllowed?:       boolean;
			types?:                     string[];
			categoryId?:                string;
			hasCompany?:                boolean;
			hasCompanyWithNoContracts?: boolean;
			hasContract?:               boolean;
			companyCountry?:            { code: string } | null;
			requireNestedObjects?:      boolean;
			requireStores?:             boolean;
      responsible?:               { id: number };
		},
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
		options: RequestOptions = {},
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
      'partners.getList',
      {
        ...filters,
        companyCountry: filters?.companyCountry ? { code: filters.companyCountry.code } : undefined,
        responsible: filters?.responsible ? { id: filters.responsible.id } : undefined,
      },
      pagination,
      sort,
      true,
      null,
      null,
      false,
      options,
    );
	}

	/**
	 * Создаёт партнёра
	 */
	static async add(partner: Partner): Promise<RpcResponse> {
		return await RpcService.makeRequest('partners.add', { partner });
	}

	/**
	 * Обновляет партнёра
	 */
	static async update(partner: Partner): Promise<RpcResponse> {
		return await RpcService.makeRequest('partners.update', { partner });
	}

	/**
	 * Удаляет партнёра
	 */
	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('partners.delete', { id });
	}
}

export default PartnersDAO;